export default __webpack_public_path__ + "static/media/achievement.6bd77811.gif";